import React, { Component } from 'react'
import { PageWrapper, Header, Button, TextField, FormikForm, Toast, FlexWrapper } from '../components'
import { Formik, Field } from 'formik'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'

class NominateGrocery extends Component {
  state = { openToast: false, isLoading: false }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.props.history.goBack()
  }
  render() {
    const { isLoading, openToast } = this.state

    return (
      <React.Fragment>
        <Header
          title={'Nominate Grocery Store'}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <PageWrapper viewPadding="22.4% 3.9% 6%">
          <FlexWrapper height={'calc(100% - 8.4%)'} justifyContent="space-between" alignItems="center">
            <Formik
              enableReinitialize
              initialValues={{
                retailerName: '',
                location: ''
              }}
              validateOnChange
              // validate
              onSubmit={async val => {
                this.setState({ isLoading: true })

                await axios.post(`${API_URL}/UserFeedbacks`, {
                  userId: Cookies.get('user_id'),
                  type: 'Nominate Grocery',
                  extra_one: val.location,
                  extra_two: val.retailerName
                })
                this.setState({ isLoading: false, openToast: true })
              }}
              render={formikBag => (
                <React.Fragment>
                  <FormikForm height="calc(100% - 8.4%)" justifyContent="space-between">
                    <div>
                      <Field
                        name="retailerName"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="text"
                            label="Retailer Name"
                            margin="30px 14px"
                            width="auto"
                            required
                            fontSize="18px"
                            fontColor="#124b5f"
                          />
                        )}
                      />
                      <Field
                        name="location"
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="text"
                            label="Location"
                            margin="30px 14px"
                            width="auto"
                            required
                            fontSize="18px"
                            fontColor="#124b5f"
                          />
                        )}
                      />
                    </div>
                    <Button volume="filled" type="submit" label="Submit" namespace="Nominate Grocery" disabled={isLoading} isLoading={isLoading} />
                  </FormikForm>
                </React.Fragment>
              )}
            />
          </FlexWrapper>
        </PageWrapper>
        <Toast open={openToast} message="This grocer has been nominated" onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default NominateGrocery



// WEBPACK FOOTER //
// ./src/pages/NominateGrocery.js